import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { getTokenExp } from "./helpers/helpers";
import './App.scss';

import LoginPage from "./components/LoginPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import MainPage from "./components/_layout/MainPage";

const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={(props) => (
        (sessionStorage.getItem('ipsadToken') && (getTokenExp() > Date.now() / 1000))
            ? <Component {...props}/>
            : <Redirect to='/login'/>
    )}/>
);

function App() {
    return (
        <BrowserRouter>
            <Switch>
                <Route
                    exact path='/login'
                    render={props =>
                        <LoginPage
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/terms_and_conditions'
                    render={props =>
                        <TermsAndConditions
                            {...props}
                        />
                    }
                />
                <Route
                    exact path='/privacy_policy'
                    render={props =>
                        <PrivacyPolicy
                            {...props}
                        />
                    }
                />
                {/*<PrivateRoute*/}
                {/*    path='/'*/}
                {/*    component={props =>*/}
                {/*        <MainPage*/}
                {/*            {...props}*/}
                {/*        />*/}
                {/*    }*/}
                {/*/>*/}
                <PrivateRoute
                    path='/'
                    component={MainPage}
                />
            </Switch>
        </BrowserRouter>
    );
}

export default App;
